export default function ProjectCard({ url, image, alt, title, text, stack, badges = [] }) {
    return (
        <a href={url} target="_blank" className="flex h-full flex-col border-customGrey border-[1px] rounded-[16px]">
            <div className="overflow-hidden w-full h-[300px] rounded-tl-[inherit] rounded-tr-[inherit] relative">
                <img className="w-full h-full object-cover object-top rounded-tl-[inherit] rounded-tr-[inherit] transform transition-transform duration-300 hover:scale-110" src={image} alt={alt} />
                {badges.length > 0 && (
                    <div className="absolute flex gap-1 justify-end top-0 left-0 p-4 h-[30%] z-30 w-full bg-gradient-to-b from-white/100 to-white/0">
                        {badges.map((badge, idx) => (
                            <span
                                key={idx}
                                className="flex w-fit h-fit items-center gap-1 px-2 py-1.5 rounded-full bg-white border border-customPurple text-customPurple font-medium text-xs shadow-md"
                                style={{boxShadow: '0 1px 4px 0 rgba(185,131,255,0.10)'}}
                            >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="8" cy="8" r="8" fill="#6563FF"/>
                                    <path d="M5.2 8.5L7.2 10.5L11 6.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                {badge.charAt(0).toUpperCase() + badge.slice(1)}
                            </span>
                        ))}
                    </div>
                )}
            </div>
            <div className="flex flex-col gap-[20px] p-[24px] grow">
                <div className="text-2xl md:text-3xl font-medium">{title}</div>
                <p className="text-md md:text-xl grow">{text}</p>
                <div className="flex justify-end gap-[20px] flex-wrap">
                    {
                        stack.length && stack.map(({id, name, image}) => (
                            <div className="relative inline-block group">
                                <img key={id} src={image} alt={name} className="stack-image" />
                                <div className="tooltip absolute left-1/2 -translate-x-1/2 -top-8 mb-2 flex-col items-center z-10">
                                    <div className="bg-customPurple text-white text-xs font-semibold rounded-lg p-2 shadow-lg whitespace-nowrap relative">
                                        {name}
                                        <span className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-customPurple"></span>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </a>
    );
}
